import React, { useState } from "react";

const imageCount = 103;

const BydgoszczGallery = () => {
  const [portraitIndices, setPortraitIndices] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageLoad = (e, index) => {
    const { naturalWidth, naturalHeight } = e.target;
    if (naturalHeight > naturalWidth) {
      setPortraitIndices((prev) => [...prev, index]);
    }
  };

  const images = Array.from({ length: imageCount }, (_, i) => {
    const num = i + 1;
    return `/images/bydgoszcz/gallery/open/gb_${num}.jpg`;
  });

  return (
    <>
      {/* GALLERY GRID */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 p-4 auto-rows-[200px] bg-black">
        {images.map((src, index) => {
          const isPortrait = portraitIndices.includes(index);

          return (
            <img
              key={index}
              src={src}
              alt={`Galeria Bydgoszcz ${index + 1}`}
              onLoad={(e) => handleImageLoad(e, index)}
              onClick={() => setSelectedImage(src)}
              className={`w-full h-full object-cover rounded shadow cursor-pointer transition-transform duration-300 hover:scale-105 ${
                isPortrait ? "row-span-2" : ""
              }`}
              loading="lazy"
            />
          );
        })}
      </div>

      {/* LIGHTBOX POPUP */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
          onClick={() => setSelectedImage(null)}
        >
          <img
            src={selectedImage}
            alt="Powiększone"
            className="max-h-[90vh] max-w-[90vw] rounded shadow-lg"
            onClick={(e) => e.stopPropagation()} // blokuje zamknięcie po kliknięciu w zdjęcie
          />
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-4 right-4 text-white text-3xl font-bold hover:text-red-400"
          >
            &times;
          </button>
        </div>
      )}
    </>
  );
};

export default BydgoszczGallery;
